<template>
    <tr class="even:bg-neutral-100"><slot/></tr>
</template>
